import { render, staticRenderFns } from "./MatchConflictsProductPrincipalAccordionTable.vue?vue&type=template&id=5ea8ddd6&scoped=true&"
import script from "./MatchConflictsProductPrincipalAccordionTable.vue?vue&type=script&lang=ts&"
export * from "./MatchConflictsProductPrincipalAccordionTable.vue?vue&type=script&lang=ts&"
import style0 from "./MatchConflictsProductPrincipalAccordionTable.vue?vue&type=style&index=0&id=5ea8ddd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea8ddd6",
  null
  
)

export default component.exports